import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import useToggle from "../../Hooks/useToggle";
import navigationContext from "../../contexts/navigationsContext";
import { navigations } from "../../Data/navigation.json";
import Drawer from "../Mobile/Drawer";
import Footer from "../Partials/Footers/HomeOne/Footer";
import HeaderOne from "../Partials/Headers/HeaderOne";
import BackToTop from "../Helpers/BackToTop";
import { getWinnerListData } from "../../services/HomeServices";
import _ from "lodash";
import { motion } from "framer-motion";
import "./WinnerList.css";

const WinnerList = () => {
  const navigationData = navigations;
  const [drawer, setDrawer] = useToggle(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await getWinnerListData();
      setData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching winners:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Drawer
        drawer={drawer}
        action={setDrawer.toggle}
        navigationData={navigationData}
      />
      <navigationContext.Provider value={{ navigationData }}>
        <HeaderOne drawerAction={setDrawer.toggle} />
      </navigationContext.Provider>

      <section className="winner-list-page">
        <div className="winner-list-container">
          <div className="winner-list-header">
            <div className="winner-list-title">
              <div className="winner-list-icon">
                <i className="fas fa-trophy"></i>
              </div>
              <div>
                <h1>Winners List</h1>
                <p>Congratulations to all our lucky winners!</p>
              </div>
            </div>
          </div>

          <div className="winner-list-content">
            {isLoading ? (
              <div className="winner-loading">
                <div className="winner-spinner"></div>
              </div>
            ) : !_.isEmpty(data) ? (
              <div className="table-responsive">
                <Table className="winner-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Winner Name</th>
                      <th>Lottery Name</th>
                      <th>Prize Won</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((winner, index) => (
                      <tr key={winner?.id || index}>
                        <td>
                          <span className="winner-rank-badge">{index + 1}</span>
                        </td>
                        <td>
                          <div className="winner-name-cell">
                            <div className="winner-avatar-small">
                              <i className="fas fa-user"></i>
                            </div>
                            <span>{winner?.winner_name || "Anonymous"}</span>
                          </div>
                        </td>
                        <td>
                          <span className="lottery-name-badge">
                            {winner?.lottery_name || "Lottery"}
                          </span>
                        </td>
                        <td>
                          <span className="prize-badge">
                            <i className="fas fa-gift"></i>
                            {winner?.prize_name || "Prize"}
                          </span>
                        </td>
                        <td>
                          <span className="date-badge">
                            <i className="far fa-calendar-alt"></i>
                            {winner?.won_at || "-"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="winner-empty-state">
                <div className="winner-empty-icon">
                  <i className="fas fa-trophy"></i>
                </div>
                <h3>No Winners Yet</h3>
                <p>Be the first to win in our exciting draws!</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
      <BackToTop />
    </motion.div>
  );
};

export default WinnerList;
